export default __webpack_public_path__ + "static/media/cern-extrabold.8b6f1a90.ttf";